import { createFileRoute, Link } from '@tanstack/react-router';

import { NewsletterSignup } from '@/components/site/newsletter-signup';
import { Cell, GridShell } from '@/components/site/shell';
import { seoHead } from '@/lib/seo';

export const Route = createFileRoute('/newsletter')({
    head: () =>
        seoHead({
            title: 'ניוזלטר',
            description:
                'הירשמו לניוזלטר של אשקלון ניוז וקבלו עדכונים ישירות למייל.',
            path: '/newsletter',
        }),
    component: NewsletterPage,
});

function NewsletterPage() {
    return (
        <GridShell activePath="/newsletter">
            <Cell className="px-6 py-12 sm:py-16">
                <p className="text-sm text-white/55">ניוזלטר</p>
                <h1 className="mt-2 max-w-2xl text-3xl font-normal tracking-tight text-white sm:text-4xl">
                    כל עדכוני אשקלון ניוז ישירות בתיבת המייל
                </h1>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/55">
                    הירשמו לקבלת עדכונים. אנחנו לא מספימים - ותוכלו לבטל את
                    ההרשמה בכל עת. ההרשמה מתבצעת דרך קישור אימות במייל (Magic
                    URL).
                </p>

                <div className="mt-8 max-w-md border border-white/10 bg-white/[0.02] p-6">
                    <NewsletterSignup id="newsletter-email-page" />
                </div>

                <p className="mt-8 text-sm text-white/55">
                    <Link to="/" className="hover:text-white">
                        חזרה לדף הבית
                    </Link>
                </p>
            </Cell>
        </GridShell>
    );
}
